import z from 'zod'

import { snakeToCamelCase } from '../../common/helpers.js'
import i18n from '../i18n.js'

export const formatLocaleForI18N = (code: string) => {
    return code.split('-')[0]
}

export const validateLocaleForI18N = (code: string) => {
    const allowed = ['da', 'en', 'fi', 'nb', 'sv']

    if (allowed.includes(code)) {
        return code
    }

    return 'en'
}

export const formatLocaleForEsisTag = (code: string) => {
    switch (code) {
        case 'nb-NO':
            return 'no-NO'
        default:
            return code
    }
}

export const translateWithFallback = (key: string, fallback: string) => {
    if (i18n.exists(key)) {
        return i18n.t(key)
    }

    return fallback
}

export const getTranslatedErrorMessage = (key: string, code: z.core.$ZodIssueCode | undefined): string | undefined => {
    if (code) {
        const customKey = snakeToCamelCase(`${key}_${code}`)
        if (i18n.exists(customKey)) {
            return i18n.t(customKey)
        }

        return i18n.t(key)
    }

    return undefined
}

export const toBase64 = (file: File) =>
    new Promise<string>((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result as string)
        reader.onerror = reject
    })
